<template>
    <div class="header--app">
        <div class="header--auth">
            <a class="header--auth__back" href="#" :class="{ visible: backLink }" @click.prevent="goBack">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18">
                    <g stroke="#FFF" stroke-width="2" fill="none" fill-rule="evenodd">
                        <path d="M10.374 17.3L2 9 10.374.7M2 9h18"/>
                    </g>
                </svg>
            </a> 
            
            <router-link class="header--auth__welcome" :to="{ name: 'welcome'}">
                <svg class="header--auth__logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 85">
                    <defs>
                        <path id="a" d="M0 .406h59.594V60H0z"/>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFF">
                        <tspan x="1" y="81">Marque</tspan>
                        </text>
                        <g>
                        <mask id="b" fill="#fff">
                            <use xlink:href="#a"/>
                        </mask>
                        <path d="M29.797 60c16.456 0 29.797-13.34 29.797-29.797S46.254.406 29.797.406C13.341.406 0 13.746 0 30.203 0 46.659 13.34 60 29.797 60" fill="#FFF" mask="url(#b)"/>
                        </g>
                        <path d="M12.749 30.78l-1.528-2.698v4.325c0 .384-.27.593-.61.593-.34 0-.611-.21-.611-.593v-5.756c0-.44.294-.651.658-.651.435 0 .67.245.857.582l1.997 3.43 1.985-3.43c.199-.349.422-.582.846-.582.375 0 .657.21.657.651v5.756c0 .384-.26.593-.6.593-.351 0-.61-.21-.61-.593v-4.325l-1.527 2.698c-.2.348-.387.593-.763.593s-.552-.245-.751-.593M19.897 30.303h2.192l-1.096-3.023-1.096 3.023zm.138-3.419c.202-.534.447-.884.958-.884.51 0 .755.35.958.884l1.99 5.232c.18.489-.075.884-.479.884-.32 0-.479-.221-.596-.546l-.415-1.151h-2.916l-.415 1.15c-.117.326-.266.547-.596.547-.404 0-.65-.395-.458-.884l1.97-5.232zM35.831 29.111c0-1.169-.778-2.055-1.955-2.055s-1.955.886-1.955 2.055c0 1.214.744 2.168 1.944 2.588 1.2-.42 1.966-1.374 1.966-2.588zm-9.676.364h.89c.932 0 1.532-.33 1.532-1.159 0-.828-.623-1.158-1.533-1.158h-.89v2.317zm11.476 3.02c-1.122.635-2.6.624-3.766.192-2.533.761-5.388.17-6.599-2.18h-1.111v1.817c0 .374-.244.579-.578.579-.322 0-.577-.205-.577-.58v-5.63c0-.375.266-.58.577-.58h1.566c1.668 0 2.623.784 2.623 2.203 0 .976-.5 1.658-1.345 1.976.878 1.374 2.4 1.896 3.944 1.669-.978-.557-1.622-1.647-1.622-2.85 0-1.794 1.323-3.111 3.133-3.111 1.8 0 3.122 1.317 3.122 3.111 0 1.203-.678 2.305-1.634 2.838a2.91 2.91 0 001.856-.385c.689-.353 1.133.544.41.93zM38 30.133v-3.546c0-.379.289-.587.637-.587.35 0 .625.208.625.587v3.362c0 1.3.698 1.97 1.744 1.97 1.034 0 1.73-.67 1.73-1.97v-3.362c0-.379.277-.587.638-.587.349 0 .626.208.626.587v3.546C44 32.079 42.617 33 41.006 33 39.383 33 38 32.079 38 30.133M46 26.601c0-.388.244-.601.53-.601h2.94c.327 0 .51.236.51.542 0 .307-.183.542-.51.542h-2.41v1.862h2.085c.326 0 .51.224.51.531 0 .306-.184.53-.51.53H47.06v1.909h2.432c.326 0 .509.235.509.542 0 .306-.183.542-.509.542H46.53c-.285 0-.529-.212-.529-.601V26.6z" fill="#28357D"/>
                    </g>
                </svg>
            </router-link>

        </div>
    </div>
</template>

<script>

    export default {
        props: {
            backLink: {
                type: Boolean,
                default: false
            },
        },

        methods: {
            goBack() {
                this.$router.go(-1)
            }
        }
    }
</script>
